/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { InfiniteMatDataSource } from '@gh/common-external-shared';
import { DialogService, InvalidFileReason, NotificationService, WaitingService, yesAnswer, yesCancelConfirmation, } from '@gh/core-ui';
import { openInNewWindow } from '@gh/core-util';
import { filter$, switchMap$ } from '@gh/rx/operators';
import { SupplierInvoicesListBusinessService } from '../../resources';
import * as i0 from "@angular/core";
import * as i1 from "../../resources";
import * as i2 from "@gh/core-ui";
import * as i3 from "@angular/router";
import * as i4 from "../../../common-external-shared/components/ext-page/ext-page.component";
import * as i5 from "../../../common-external-shared/components/ext-uploader/ext-uploader.component";
import * as i6 from "@angular/material/sort";
import * as i7 from "../../../common-external-shared/directives/ext-if-query.directive";
import * as i8 from "../../../common-external-shared/components/ext-load-tracker/ext-load-tracker.component";
import * as i9 from "@angular/flex-layout/flex";
import * as i10 from "@angular/material/table";
import * as i11 from "../../../common-external-shared/infinite-scroll/table/ext-infinite-table.directive";
import * as i12 from "../../../common-external-shared/infinite-scroll/table/ext-infinite-table-viewer.directive";
import * as i13 from "@angular/material/button";
import * as i14 from "../../../common-external-shared/infinite-scroll/table/ext-infinite-row.directive";
import * as i15 from "../../../common-external-shared/infinite-scroll/list/ext-infinite-list.component";
import * as i16 from "../../../common-external-shared/infinite-scroll/list/ext-infinite-scroll-for.directive";
import * as i17 from "@angular/material/card";
import * as i18 from "../../../core-mls/translation/translate.pipe";
import * as i19 from "../../../core-type/pipes/type-format.pipe";
function SupplierInvoicesListComponent_mat_table_6_mat_header_cell_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_file_name"));
} }
function SupplierInvoicesListComponent_mat_table_6_mat_cell_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoice_r11 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(invoice_r11.fileName);
} }
function SupplierInvoicesListComponent_mat_table_6_mat_header_cell_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_uploaded_date"));
} }
function SupplierInvoicesListComponent_mat_table_6_mat_cell_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "typeFormat");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoice_r12 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, invoice_r12.updatedDate, "ShortDate"));
} }
function SupplierInvoicesListComponent_mat_table_6_mat_header_cell_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-cell");
} }
function SupplierInvoicesListComponent_mat_table_6_mat_cell_9_Template(rf, ctx) { if (rf & 1) {
    var _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-cell", 23);
    i0.ɵɵelementStart(1, "button", 24);
    i0.ɵɵlistener("click", function SupplierInvoicesListComponent_mat_table_6_mat_cell_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r15); var invoice_r13 = ctx.$implicit; var ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.delete(invoice_r13); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 25);
    i0.ɵɵlistener("click", function SupplierInvoicesListComponent_mat_table_6_mat_cell_9_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r15); var invoice_r13 = ctx.$implicit; var ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.view(invoice_r13); });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "lbl_delete"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, "lbl_view"));
} }
function SupplierInvoicesListComponent_mat_table_6_mat_header_row_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function SupplierInvoicesListComponent_mat_table_6_mat_row_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row", 26);
} if (rf & 2) {
    var invoice_r17 = ctx.$implicit;
    i0.ɵɵproperty("ghExtInfiniteRow", invoice_r17);
} }
function SupplierInvoicesListComponent_mat_table_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-table", 7);
    i0.ɵɵelementContainerStart(1, 8);
    i0.ɵɵtemplate(2, SupplierInvoicesListComponent_mat_table_6_mat_header_cell_2_Template, 3, 3, "mat-header-cell", 9);
    i0.ɵɵtemplate(3, SupplierInvoicesListComponent_mat_table_6_mat_cell_3_Template, 2, 1, "mat-cell", 10);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(4, 11);
    i0.ɵɵtemplate(5, SupplierInvoicesListComponent_mat_table_6_mat_header_cell_5_Template, 3, 3, "mat-header-cell", 12);
    i0.ɵɵtemplate(6, SupplierInvoicesListComponent_mat_table_6_mat_cell_6_Template, 3, 4, "mat-cell", 13);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(7, 14);
    i0.ɵɵtemplate(8, SupplierInvoicesListComponent_mat_table_6_mat_header_cell_8_Template, 1, 0, "mat-header-cell", 15);
    i0.ɵɵtemplate(9, SupplierInvoicesListComponent_mat_table_6_mat_cell_9_Template, 7, 6, "mat-cell", 16);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(10, SupplierInvoicesListComponent_mat_table_6_mat_header_row_10_Template, 1, 0, "mat-header-row", 17);
    i0.ɵɵtemplate(11, SupplierInvoicesListComponent_mat_table_6_mat_row_11_Template, 1, 1, "mat-row", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = i0.ɵɵnextContext();
    var _r2 = i0.ɵɵreference(9);
    i0.ɵɵproperty("dataSource", ctx_r0.dataSource)("tracker", _r2)("trackBy", ctx_r0.getInvoiceId);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r0.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r0.displayedColumns);
} }
function SupplierInvoicesListComponent_div_7_mat_card_2_Template(rf, ctx) { if (rf & 1) {
    var _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-card");
    i0.ɵɵelementStart(1, "mat-card-content");
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵelementStart(3, "div", 31);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 32);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 33);
    i0.ɵɵelementStart(9, "div", 31);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 32);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "mat-card-actions");
    i0.ɵɵelementStart(16, "button", 24);
    i0.ɵɵlistener("click", function SupplierInvoicesListComponent_div_7_mat_card_2_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r21); var invoice_r19 = ctx.$implicit; var ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.delete(invoice_r19); });
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "button", 25);
    i0.ɵɵlistener("click", function SupplierInvoicesListComponent_div_7_mat_card_2_Template_button_click_19_listener() { i0.ɵɵrestoreView(_r21); var invoice_r19 = ctx.$implicit; var ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.view(invoice_r19); });
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var invoice_r19 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 6, "lbl_file_name"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(invoice_r19.fileName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 8, "lbl_uploaded_date"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(14, 10, invoice_r19.updatedDate, "ShortDate"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 13, "lbl_delete"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 15, "lbl_view"));
} }
function SupplierInvoicesListComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "gh-ext-infinite-list", 28);
    i0.ɵɵtemplate(2, SupplierInvoicesListComponent_div_7_mat_card_2_Template, 22, 17, "mat-card", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = i0.ɵɵnextContext();
    var _r2 = i0.ɵɵreference(9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("itemHeight", 170)("tracker", _r2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ghExtInfiniteScrollForOf", ctx_r1.dataSource);
} }
var SupplierInvoicesListComponent = /** @class */ (function () {
    function SupplierInvoicesListComponent(businessService, notifications, dialogService, waitings, route) {
        this.businessService = businessService;
        this.notifications = notifications;
        this.dialogService = dialogService;
        this.waitings = waitings;
        this.route = route;
        this.displayedColumns = ['fileName', 'updatedDate', 'id'];
    }
    SupplierInvoicesListComponent.prototype.ngOnInit = function () {
        this.subscribeToNavigation();
    };
    SupplierInvoicesListComponent.prototype.getInvoiceId = function (index, invoice) {
        return invoice.id;
    };
    SupplierInvoicesListComponent.prototype.delete = function (invoice) {
        var _this = this;
        this.dialogService
            .confirmation(yesCancelConfirmation('msg_inv_delete')).pipe(filter$(yesAnswer), switchMap$(function () {
            return _this.businessService.delete(invoice.id).pipe(_this.waitings.operator());
        }))
            .subscribe(function () {
            _this.notifications.success('msg_invoice_deleted');
            _this.dataSource.fire();
        }, this.notifications.processAll);
    };
    SupplierInvoicesListComponent.prototype.view = function (invoice) {
        openInNewWindow(invoice.fileUrl);
    };
    SupplierInvoicesListComponent.prototype.onUploadError = function (event) {
        var _a;
        this.notifications.error((_a = {},
            _a[InvalidFileReason.TooLarge] = 'msg_item_picture_not_correct',
            _a[InvalidFileReason.NotAccepted] = 'msg_picture_invalid_extension',
            _a)[event.reason]);
    };
    SupplierInvoicesListComponent.prototype.onUploadSuccess = function () {
        this.loadInvoices();
    };
    SupplierInvoicesListComponent.prototype.loadInvoices = function () {
        this.dataSource = InfiniteMatDataSource.wrap(this.businessService.getAll());
        this.dataSource.sort = this.sort;
    };
    SupplierInvoicesListComponent.prototype.subscribeToNavigation = function () {
        var _this = this;
        this.route
            .params
            .subscribe(function () { return _this.loadInvoices(); });
    };
    SupplierInvoicesListComponent.ɵfac = function SupplierInvoicesListComponent_Factory(t) { return new (t || SupplierInvoicesListComponent)(i0.ɵɵdirectiveInject(i1.SupplierInvoicesListBusinessService), i0.ɵɵdirectiveInject(i2.NotificationService), i0.ɵɵdirectiveInject(i2.DialogService), i0.ɵɵdirectiveInject(i2.WaitingService), i0.ɵɵdirectiveInject(i3.ActivatedRoute)); };
    SupplierInvoicesListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SupplierInvoicesListComponent, selectors: [["gh-invoices"]], viewQuery: function SupplierInvoicesListComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatSort, true);
        } if (rf & 2) {
            var _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
        } }, decls: 10, vars: 5, consts: [[3, "title"], ["label", "lbl_upload_invoice", "url", "/invoices", "accept", "image/png,image/jpeg,image/jpg,application/pdf", "maxSize", "10mb", 3, "invalid", "success"], ["matSort", ""], ["ghExtInfiniteTable", "", 3, "dataSource", "tracker", "trackBy", 4, "ghExtIfQuery"], ["fxLayout", "column", 4, "ghExtIfQuery"], ["fxFlex", ""], ["tracker", "ghExtLoadTracker"], ["ghExtInfiniteTable", "", 3, "dataSource", "tracker", "trackBy"], ["matColumnDef", "fileName"], ["fxFlex", "55%", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "55%", 4, "matCellDef"], ["matColumnDef", "updatedDate"], ["fxFlex", "15%", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "15%", 4, "matCellDef"], ["matColumnDef", "id"], [4, "matHeaderCellDef"], ["class", "cell-align-right", 4, "matCellDef"], [4, "matHeaderRowDef"], [3, "ghExtInfiniteRow", 4, "matRowDef", "matRowDefColumns"], ["fxFlex", "55%", "mat-sort-header", ""], ["fxFlex", "55%"], ["fxFlex", "15%", "mat-sort-header", ""], ["fxFlex", "15%"], [1, "cell-align-right"], ["type", "button", "color", "primary", "mat-flat-button", "", 1, "small", "cell-button", 3, "click"], ["type", "button", "mat-stroked-button", "", 1, "small", "cell-button", 3, "click"], [3, "ghExtInfiniteRow"], ["fxLayout", "column"], [3, "itemHeight", "tracker"], [4, "ghExtInfiniteScrollFor", "ghExtInfiniteScrollForOf"], [1, "card-content-item"], [1, "card-content-item-title"], [1, "card-content-item-value"], [1, "card-content-item", "full-width"]], template: function SupplierInvoicesListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "gh-ext-page");
            i0.ɵɵelement(1, "gh-ext-page-title", 0);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "gh-ext-page-content");
            i0.ɵɵelementStart(4, "gh-ext-uploader", 1);
            i0.ɵɵlistener("invalid", function SupplierInvoicesListComponent_Template_gh_ext_uploader_invalid_4_listener($event) { return ctx.onUploadError($event); })("success", function SupplierInvoicesListComponent_Template_gh_ext_uploader_success_4_listener() { return ctx.onUploadSuccess(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerStart(5, 2);
            i0.ɵɵtemplate(6, SupplierInvoicesListComponent_mat_table_6_Template, 12, 5, "mat-table", 3);
            i0.ɵɵtemplate(7, SupplierInvoicesListComponent_div_7_Template, 3, 3, "div", 4);
            i0.ɵɵelement(8, "gh-ext-load-tracker", 5, 6);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "lbl_invoices"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ghExtIfQuery", "gt-sm");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ghExtIfQuery", "lt-md");
        } }, directives: [i4.ExtPageComponent, i4.ExtPageTitleDirective, i4.ExtPageContentComponent, i5.ExtUploaderComponent, i6.MatSort, i7.ExtIfQueryDirective, i8.ExtLoadTrackerComponent, i9.DefaultFlexDirective, i10.MatTable, i11.ExtInfiniteTableDirective, i12.ExtInfiniteTableViewerDirective, i10.MatColumnDef, i10.MatHeaderCellDef, i10.MatCellDef, i10.MatHeaderRowDef, i10.MatRowDef, i10.MatHeaderCell, i6.MatSortHeader, i10.MatCell, i13.MatButton, i10.MatHeaderRow, i10.MatRow, i14.ExtInfiniteRowDirective, i9.DefaultLayoutDirective, i15.ExtInfiniteListComponent, i16.ExtInfiniteScrollForDirective, i17.MatCard, i17.MatCardContent, i17.MatCardActions], pipes: [i18.TranslatePipe, i19.TypeFormatPipe], encapsulation: 2 });
    return SupplierInvoicesListComponent;
}());
export { SupplierInvoicesListComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierInvoicesListComponent, [{
        type: Component,
        args: [{
                selector: 'gh-invoices',
                templateUrl: 'supplier-invoices-list.component.html',
            }]
    }], function () { return [{ type: i1.SupplierInvoicesListBusinessService }, { type: i2.NotificationService }, { type: i2.DialogService }, { type: i2.WaitingService }, { type: i3.ActivatedRoute }]; }, { sort: [{
            type: ViewChild,
            args: [MatSort, { static: false }]
        }] }); })();
